import translation from "./en.json";

/**
 * Explicit English FrontDesk+ translation resource for bounded browser builds.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const resources = { en: { translation: englishFrontDeskTranslation } };
 * ```
 */
export const englishFrontDeskTranslation = translation;
